import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-column" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["textContent"]

import { onBeforeMount, ref, computed, toRefs } from 'vue';
import Chip from 'primevue/chip';
import CheckboxForm from '@/components/Forms/CheckboxForm';
import { useServicesStore, useAuthStore } from '@/store';
import { PERMISSIONS } from '@/enum/permissions';
import { can } from '@/composables';
import { ServiceInterface } from '@/types';

interface Props {
  organizationId: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Services',
  props: {
    organizationId: {}
  },
  setup(__props: any) {

const props = __props;
const servicesStore = useServicesStore();
const authStore = useAuthStore();
const { organizationId } = toRefs(props);
const permissionToUpdate = can([PERMISSIONS.ORGANIZATION_SYNC_SERVICES]);

const dirty = ref(false);

// eslint-disable-next-line
// @ts-ignore
const activeEventTypes = computed<ServiceInterface[]>(() =>
  !authStore.currentInstanceIsMasterTenant
    ? servicesStore.services?.filter((service) => service.checked)
    : servicesStore.services,
);

const onSave = async () => {
  const result = await servicesStore.saveServices(organizationId.value);
  result === 200
    ? servicesStore.doToast('Services have been saved', 'Saved')
    : servicesStore.doToast('Services have not been saved', 'Error', true);

  dirty.value = false;
};

const onUpdate = (id: string, checked: boolean) => {
  if (!dirty.value) {
    dirty.value = true;
  }
  servicesStore.updateService({ id, checked });
};

const onCancel = () => {
  dirty.value = false;
  servicesStore.getServices(organizationId.value);
};

onBeforeMount(() => {
  if (can([PERMISSIONS.ORGANIZATION_SERVICES_INDEX])) servicesStore.getServices(organizationId.value);
});

const icons: Record<string, string> = {
  'Caseload Management': 'settings',
  Consultation: 'assignment',
  Evaluation: 'assignment_turned_in',
  'IEP Meeting': 'assignment_ind',
  'Record Review': 'rate_review',
  Session: 'perm_contact_calendar',
  'Response to Intervention': 'support',
};

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Card = _resolveComponent("Card")!

  return (!_unref(authStore).currentInstanceIsMasterTenant && _unref(permissionToUpdate))
    ? (_openBlock(), _createBlock(_unref(CheckboxForm), {
        key: 0,
        title: "Event Types",
        items: _unref(servicesStore).services,
        "update-item": onUpdate,
        save: onSave,
        loading: _unref(servicesStore).loading && _unref(permissionToUpdate),
        cancel: onCancel,
        dirty: dirty.value && _unref(permissionToUpdate),
        "class-name": "checkbox-form"
      }, null, 8, ["items", "loading", "dirty"]))
    : (_openBlock(), _createBlock(_component_Card, {
        key: 1,
        class: "form-card p-fluid checkbox-form"
      }, {
        header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("h2", null, "Event Types", -1)
        ]))]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_unref(servicesStore).loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                    return _createVNode(_component_Skeleton, {
                      key: n,
                      width: "100%",
                      height: "24px"
                    })
                  }), 64))
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeEventTypes.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "mb-2"
              }, [
                _createVNode(_unref(Chip), { class: "pl-0 pr-1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      name: icons[item.name],
                      size: "text-base",
                      class: "ml-1",
                      style: _normalizeStyle(`color: #${item.color}`)
                    }, null, 8, ["name", "style"]),
                    _createElementVNode("span", {
                      class: "p-chip-text ml-1 font-semibold",
                      textContent: _toDisplayString(item.name)
                    }, null, 8, _hoisted_3)
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }))
}
}

})